export function asyncResult(data) {
    return data ? { loading: false, data } : { loading: true };
}
//# sourceMappingURL=helpers.js.map